export default __webpack_public_path__ + "static/media/fav-list-added.7b90cf86.svg";